const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/payouts/index.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/payouts/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type Tab = "unpaid" | "history";